import React, { Component } from 'react'
import parse from 'html-react-parser'

export class Serviceblock extends Component {
    
    render() {

        return (
            // <!-- Service Start -->
            <div className="section techwix-service-section-03" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/service-bg3.jpg)` }}>
                <div className="container">
                    {/* <!-- Service Wrap Start --> */}
                    <div className="service-wrap-03">
                        <div className="row">
                            {
                                this.props.sblocks ?
                                    this.props.sblocks.map((item, i) =>
                                        <div className="col-xl-3 col-md-6" key={i}>
                                            <div className="service-item-03" >
                                                <div className="service-img">
                                                    <img src={item.service_icon.toString()} alt="" />
                                                </div>
                                                <div className="service-content">
                                                    <h3 className="title">
                                                        <a href={item.service_page_link.replace("https://rcweb.kanopuswebsolutions.com", "")}>{parse(item.services_heading)}</a>
                                                    </h3>
                                                    <p>{item.service_text}</p>
                                                    <div className="read-more">
                                                        <a href={item.service_page_link.replace("https://rcweb.kanopuswebsolutions.com", "")}><i className="fas fa-plus"></i> Read More</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) :
                                    ''
                            }
                        </div>
                    </div>
                    {/* <!-- Service Wrap End --> */}
                </div>
            </div>
        )
    }
}

export default Serviceblock